// @flow
import { none, some, type Option } from 'fp-ts/lib/Option';

export const isChainable = m => typeof m.chain === 'function';

export const chain = (f: Function) => (m: Option<any>): Option<any> => {
  if (!isChainable(m)) {
    throw new TypeError('chain: argument provided to chain must be a function returning a chainable');
  }
  return m.chain(f);
};

export const map = <A, B, C>(f: (A) => B) => (x): C => x.map(f);

export const fromEmpty = (val: String | Array<any> | boolean): Option<any> => {
  switch (true) {
    case typeof val === 'boolean':
      return val === true ? some(val) : none;
    case !Array.isArray(val) && typeof val !== 'string':
      return some(val);
    default:
      return val.length ? some(val) : none;
  }
};

export const composeK = (...args: Array<Function>): Function => {
  const fns = args.slice().reverse();
  const head = fns[0];

  if (fns.length === 1) {
    return head;
  }

  const tail: Function = fns.slice(1).reduce((comp, fn) => (m) => {
    if (!isChainable(m)) {
      throw new TypeError('composeK: chain returning functions required.');
    }
    return comp(m).chain(fn);
  }, x => x);

  return x => tail(head(x));
};



// WEBPACK FOOTER //
// ./src/helpers/typeclasses.js